import { constants } from 'app/client/store/reducers/socket';
import { constants as appConstants } from 'app/client/store/reducers/app';

export default {
  /**
   * Define the listeners for the App Component.
   *
   * @param {Function} dispatch The dispatch method.
   *
   * @returns {Object} The listeners to bind.
   */
  getListeners: ({ dispatch }) => [
    {
      event: 'connected',
      key: 'socket-state--connected',
      callback: () => dispatch({ type: constants.connected, payload: true }),
    },
    {
      event: 'closed',
      key: 'socket-state--closed',
      callback: () => dispatch({ type: constants.connected, payload: false }),
    },
    {
      event: 'unauthorized',
      key: 'socket-state--unauthorized',
      callback: () => dispatch({ type: constants.connected, payload: false }),
    },
  ],

  /**
   * Update the list if one of the following events occur.
   *
   * @param {Function} dispatch The dispatcher.
   *
   * @return {Object} The project list subscriptions.
   */
  getSubscriptions: ({ dispatch }) => [
    {
      channel: 'deployments',
      events: {
        /**
         * Let te app know a new version is deployed.
         */
        finished: ({ repository }) => {
          if (repository === 'frontend-portal') {
            dispatch({ type: appConstants.setNewVersion, payload: true });
          }
        },
      },
    },
  ],
};
